// extracted by mini-css-extract-plugin
export var badge = "icon-button-module--badge--95c9f";
export var button = "icon-button-module--button--94ed4";